@if (shouldShowStatus()) {
  <div
    class="status-info flex-shrink-0"
    (click)="stopPropagation($event)"
    (keydown.enter)="stopPropagation($event)"
    (keydown.space)="stopPropagation($event)">
    <mtm-status-select
      [value]="getSafeVariantStatus()"
      [options]="assetStatusOptions"
      [fallbackOption]="notAffectedOption"
      [disabled]="isDropdownDisabled()"
      (valueChange)="onChangeStatus($event.value)" />
  </div>
}
